import gql from 'not-graphql-tag';
import useAuthQuery from './useAuthQuery';
import {
  AccountEligibilityParams,
  AccountEligibilityResponse,
} from '../__generated__/pge-types';

const GET_ACCOUNT_ELIGIBILITY_QUERY = gql`
  query getAccountEligibilty($params: AccountEligibilityParams) {
    getAccountEligibilty(params: $params) {
      isFraud
      isBadDebt
    }
  }
`;

export const useGetAccountEligibiltyQuery = () => {
  const { refetch, loading, error, data } = useAuthQuery<
    { getAccountEligibilty: AccountEligibilityResponse },
    { params: AccountEligibilityParams }
  >(GET_ACCOUNT_ELIGIBILITY_QUERY, {
    skip: true,
  });
  return {
    refetch,
    loading,
    error,
    data,
  };
};

export default useGetAccountEligibiltyQuery;
